export const MAP_LANDMARKS_EDIT_CREATE_OPEN_MODAL = "MAP_LANDMARKS_EDIT_CREATE_OPEN_MODAL";
export const MAP_LANDMARKS_EDIT_CREATE_OPEN_MODAL_EDIT = "MAP_LANDMARKS_EDIT_CREATE_OPEN_MODAL_EDIT";

export const MAP_LANDMARKS_GET_LANDMARK = "MAP_LANDMARKS_GET_LANDMARK";
export const MAP_LANDMARKS_GET_LANDMARK_RESPONSE = "MAP_LANDMARKS_GET_LANDMARK_RESPONSE";

export const MAP_LANDMARKS_EDIT_CREATE_LANDMARK = "MAP_LANDMARKS_EDIT_CREATE_LANDMARK";
export const MAP_LANDMARKS_EDIT_CREATE_LANDMARK_RESPONSE = "MAP_LANDMARKS_EDIT_CREATE_LANDMARK_RESPONSE";

export const MAP_LANDMARKS_EDIT_IMPORT_OPEN_MODAL = "MAP_LANDMARKS_EDIT_IMPORT_OPEN_MODAL"